var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutForm",
    [
      _vm.$wait.is("event")
        ? _c(
            "div",
            { staticClass: "loading" },
            [_c("Spinner", { attrs: { height: 40, width: 40 } })],
            1
          )
        : [
            _vm.error
              ? [_c("button", { attrs: { type: "button" } })]
              : [
                  _vm.id
                    ? _c("div", { staticClass: "form__title" }, [
                        _c("h1", [
                          _vm.formData.event
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.formData.event.eventName)),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [_vm._v("Edit Activity")]),
                        ]),
                      ])
                    : _c("div", { staticClass: "form__title" }, [
                        _c("h1", [
                          _vm.formData.event
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.formData.event.eventName)),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [_vm._v("Create Activity")]),
                        ]),
                      ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "form",
                      attrs: { novalidate: "" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.submit.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "fieldset",
                        { staticClass: "form__group" },
                        [
                          _c("ValidationAlert", {
                            attrs: {
                              "error-list": _vm.errors.collect("server"),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "form__group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.formData.activityName,
                                  expression: "formData.activityName",
                                },
                                { name: "validate", rawName: "v-validate" },
                              ],
                              staticClass: "form__control",
                              attrs: {
                                id: "activityName",
                                name: "activityName",
                                placeholder:
                                  "Enter a name for your Activity...",
                                required: "",
                              },
                              domProps: { value: _vm.formData.activityName },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.formData,
                                    "activityName",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form__label",
                                attrs: { for: "activityName" },
                              },
                              [_vm._v("Activity name")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "form__validation" }, [
                              _vm._v(_vm._s(_vm.errors.first("activityName"))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.formData.start.dateTimeString !== "" &&
                          _vm.formData.end.dateTimeString !== ""
                            ? [
                                _c("FormControlDatetimePicker", {
                                  attrs: {
                                    "default-value": _vm.startDate,
                                    "min-date": _vm.eventStartDate,
                                    "max-date": _vm.eventEndDate,
                                    label: "Activity Start Date",
                                  },
                                  model: {
                                    value: _vm.formData.start.dateTimeString,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.start,
                                        "dateTimeString",
                                        $$v
                                      )
                                    },
                                    expression: "formData.start.dateTimeString",
                                  },
                                }),
                                _vm._v(" "),
                                !_vm.showIndepthEndDateSelector
                                  ? _c(
                                      "div",
                                      { staticClass: "form__group" },
                                      [
                                        _c("DurationDropdown", {
                                          attrs: { name: "duration" },
                                          on: { input: _vm.updateDuration },
                                          model: {
                                            value: _vm.duration,
                                            callback: function ($$v) {
                                              _vm.duration = $$v
                                            },
                                            expression: "duration",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _c("FormControlDatetimePicker", {
                                      attrs: {
                                        "default-value": _vm.endDate,
                                        "min-date": _vm.eventStartDate,
                                        "max-date": _vm.eventEndDate,
                                        label: "Activity End Date",
                                      },
                                      model: {
                                        value: _vm.formData.end.dateTimeString,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.end,
                                            "dateTimeString",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.end.dateTimeString",
                                      },
                                    }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "dummy-link",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        _vm.showIndepthEndDateSelector =
                                          !_vm.showIndepthEndDateSelector
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        !_vm.showIndepthEndDateSelector
                                          ? "Manually enter date"
                                          : "Select duration"
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            : _c(
                                "div",
                                { staticClass: "loading" },
                                [
                                  _c("Spinner", {
                                    attrs: { height: 40, width: 40 },
                                  }),
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c("div", { staticClass: "form__group" }, [
                            _c("div", { staticClass: "toggle-group" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.formData.showDate,
                                    expression: "formData.showDate",
                                  },
                                  { name: "validate", rawName: "v-validate" },
                                ],
                                staticClass: "toggle",
                                attrs: {
                                  id: "show-date",
                                  name: "showDate",
                                  type: "radio",
                                  required: "",
                                },
                                domProps: {
                                  value: true,
                                  checked: _vm.formData.showDate === true,
                                  checked: _vm._q(_vm.formData.showDate, true),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.formData,
                                      "showDate",
                                      true
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "toggle",
                                  attrs: { for: "show-date" },
                                },
                                [_vm._v("Yes")]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.formData.showDate,
                                    expression: "formData.showDate",
                                  },
                                  { name: "validate", rawName: "v-validate" },
                                ],
                                staticClass: "toggle",
                                attrs: {
                                  id: "hide-date",
                                  name: "showDate",
                                  type: "radio",
                                  required: "",
                                },
                                domProps: {
                                  value: false,
                                  checked: _vm.formData.showDate === false,
                                  checked: _vm._q(_vm.formData.showDate, false),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.formData,
                                      "showDate",
                                      false
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "toggle",
                                  attrs: { for: "hide-date" },
                                },
                                [_vm._v("No")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("label", { staticClass: "form__label" }, [
                              _vm._v("Show date on the app?"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form__validation" }, [
                              _vm._v(_vm._s(_vm.errors.first("showDate"))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("DealTypeDropdown", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            attrs: {
                              name: "dealType",
                              label: "Select deal type",
                            },
                            model: {
                              value: _vm.formData.activityType,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "activityType", $$v)
                              },
                              expression: "formData.activityType",
                            },
                          }),
                          _vm._v(" "),
                          _vm.showRegistration
                            ? _c("div", { staticClass: "form__group" }, [
                                _c("div", { staticClass: "toggle-group" }, [
                                  _c("div", { staticClass: "toggle-group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.formData.registrable,
                                          expression: "formData.registrable",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                        },
                                      ],
                                      staticClass: "toggle",
                                      attrs: {
                                        id: "registrable",
                                        name: "registrable",
                                        type: "radio",
                                        required: "",
                                      },
                                      domProps: {
                                        value: true,
                                        checked:
                                          _vm.formData.registrable === true,
                                        checked: _vm._q(
                                          _vm.formData.registrable,
                                          true
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.formData,
                                            "registrable",
                                            true
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "toggle",
                                        attrs: { for: "registrable" },
                                      },
                                      [_vm._v("Yes")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.formData.registrable,
                                          expression: "formData.registrable",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                        },
                                      ],
                                      staticClass: "toggle",
                                      attrs: {
                                        id: "not-registrable",
                                        name: "registrable",
                                        type: "radio",
                                        required: "",
                                      },
                                      domProps: {
                                        value: false,
                                        checked:
                                          _vm.formData.registrable === false,
                                        checked: _vm._q(
                                          _vm.formData.registrable,
                                          false
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.formData,
                                            "registrable",
                                            false
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "toggle",
                                        attrs: { for: "not-registrable" },
                                      },
                                      [_vm._v("No")]
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("label", { staticClass: "form__label" }, [
                                  _vm._v("Is registrable?"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form__validation" }, [
                                  _vm._v(
                                    _vm._s(_vm.errors.first("registrable"))
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "form__group" }, [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.formData.activityDescription,
                                  expression: "formData.activityDescription",
                                },
                                { name: "validate", rawName: "v-validate" },
                              ],
                              staticClass: "form__control",
                              attrs: {
                                id: "activityDescription",
                                name: "activityDescription",
                                placeholder:
                                  "Enter a description for your Activity...",
                              },
                              domProps: {
                                value: _vm.formData.activityDescription,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.formData,
                                    "activityDescription",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form__label",
                                attrs: { for: "activityDescription" },
                              },
                              [_vm._v("Activity description")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "form__validation" }, [
                              _vm._v(
                                _vm._s(_vm.errors.first("activityDescription"))
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("FormControlUser", {
                                attrs: {
                                  name: "chairpeople",
                                  label: "Chair People",
                                  multiple: true,
                                },
                                model: {
                                  value: _vm.formData.chairpeople,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "chairpeople", $$v)
                                  },
                                  expression: "formData.chairpeople",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "form__validation" }, [
                                _vm._v(_vm._s(_vm.errors.first("chairpeople"))),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "form__group" }, [
                            _c("div", { staticClass: "form__validation" }, [
                              _vm._v(
                                _vm._s(_vm.errors.first("activityLocation"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form__location-wrapper" },
                              [
                                _c("div", [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "form__label",
                                      attrs: { for: "activityLocation" },
                                    },
                                    [_vm._v("Activity location")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form__location" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.formData.activityLocation,
                                          expression:
                                            "formData.activityLocation",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                        },
                                      ],
                                      staticClass: "form__control",
                                      attrs: {
                                        id: "activityLocation",
                                        name: "activityLocation",
                                        placeholder:
                                          "Enter a location for your Activity...",
                                        required: "",
                                      },
                                      domProps: {
                                        value: _vm.formData.activityLocation,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.formData,
                                            "activityLocation",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn--primary",
                                        attrs: { type: "button" },
                                        on: { click: _vm.onLocationChanged },
                                      },
                                      [_vm._v("Find Location")]
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "form__button-wrapper" },
                                  [
                                    _vm.hotel
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "form__from-hotel dummy-link",
                                            attrs: { type: "button" },
                                            on: {
                                              click: _vm.setActivityFromHotel,
                                            },
                                          },
                                          [_vm._v("Or from hotel...")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "form__location-manual dummy-link",
                                        attrs: { type: "button" },
                                        on: { click: _vm.toggleManualLocation },
                                      },
                                      [_vm._v("Manual Address")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.showLocationDetails && !_vm.manualLocation
                            ? _c("div", { staticClass: "form__address" }, [
                                _vm.formData.website
                                  ? _c(
                                      "span",
                                      { staticClass: "form__detail" },
                                      [
                                        _vm._v("Website: "),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.formData.website,
                                              target: "_blank",
                                              rel: "noopener noreferrer",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.formData.website))]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.formData.phoneNumber
                                  ? _c(
                                      "span",
                                      { staticClass: "form__detail" },
                                      [
                                        _vm._v(
                                          "Phone Number: " +
                                            _vm._s(_vm.formData.phoneNumber)
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.formData.address
                                  ? _c(
                                      "span",
                                      { staticClass: "form__detail" },
                                      [
                                        _vm._v(
                                          "Address: " +
                                            _vm._s(_vm.formData.address)
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.formData.lat && _vm.formData.lng
                                  ? _c(
                                      "span",
                                      { staticClass: "form__detail" },
                                      [
                                        _vm._v(
                                          "Lat/Lng: " +
                                            _vm._s(_vm.formData.lat) +
                                            ", " +
                                            _vm._s(_vm.formData.lng)
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.formData.rating
                                  ? _c(
                                      "span",
                                      { staticClass: "form__detail" },
                                      [
                                        _vm._v(
                                          "Rating: " +
                                            _vm._s(_vm.formData.rating)
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.formData.directionUrl
                                  ? _c(
                                      "span",
                                      { staticClass: "form__detail" },
                                      [
                                        _vm._v("Direction URL: "),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.formData.directionUrl,
                                              target: "_blank",
                                              rel: "noopener noreferrer",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.formData.directionUrl)
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.formData.activityRoom
                                  ? _c(
                                      "span",
                                      { staticClass: "form__detail" },
                                      [
                                        _vm._v(
                                          "Room: " +
                                            _vm._s(_vm.formData.activityRoom)
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.formData.activityBackgroundImage
                                  ? _c(
                                      "div",
                                      { staticClass: "form__background" },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.formData
                                              .activityBackgroundImage,
                                            alt: "Background Image",
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.manualLocation
                            ? _c(
                                "div",
                                { staticClass: "form__location-details" },
                                [
                                  _c("div", { staticClass: "form__group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.formData.website,
                                          expression: "formData.website",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                        },
                                      ],
                                      staticClass: "form__control",
                                      attrs: {
                                        id: "website",
                                        name: "website",
                                        placeholder:
                                          "Enter a website for your Activity...",
                                      },
                                      domProps: { value: _vm.formData.website },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.formData,
                                            "website",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "form__label",
                                        attrs: { for: "website" },
                                      },
                                      [_vm._v("Activity website")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "form__validation" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.errors.first("website"))
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form__group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.formData.phoneNumber,
                                          expression: "formData.phoneNumber",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                        },
                                      ],
                                      staticClass: "form__control",
                                      attrs: {
                                        id: "phoneNumber",
                                        name: "phoneNumber",
                                        placeholder:
                                          "Enter a phone number for your Activity...",
                                      },
                                      domProps: {
                                        value: _vm.formData.phoneNumber,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.formData,
                                            "phoneNumber",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "form__label",
                                        attrs: { for: "phoneNumber" },
                                      },
                                      [_vm._v("Activity phone number")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "form__validation" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors.first("phoneNumber")
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form__group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.formData.lat,
                                          expression: "formData.lat",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                        },
                                      ],
                                      staticClass: "form__control",
                                      attrs: {
                                        id: "lat",
                                        name: "lat",
                                        type: "number",
                                        placeholder:
                                          "Enter a latitude for your Activity...",
                                      },
                                      domProps: { value: _vm.formData.lat },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.formData,
                                            "lat",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "form__label",
                                        attrs: { for: "lat" },
                                      },
                                      [_vm._v("Activity latitude")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "form__validation" },
                                      [_vm._v(_vm._s(_vm.errors.first("lat")))]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form__group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.formData.lng,
                                          expression: "formData.lng",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                        },
                                      ],
                                      staticClass: "form__control",
                                      attrs: {
                                        id: "lng",
                                        name: "lng",
                                        type: "number",
                                        placeholder:
                                          "Enter a longitude for your Activity...",
                                      },
                                      domProps: { value: _vm.formData.lng },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.formData,
                                            "lng",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "form__label",
                                        attrs: { for: "lng" },
                                      },
                                      [_vm._v("Activity longitude")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "form__validation" },
                                      [_vm._v(_vm._s(_vm.errors.first("lng")))]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form__group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.formData.rating,
                                          expression: "formData.rating",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                        },
                                      ],
                                      staticClass: "form__control",
                                      attrs: {
                                        id: "rating",
                                        name: "rating",
                                        type: "number",
                                        min: "0.0",
                                        max: "5.0",
                                        step: "0.1",
                                        placeholder:
                                          "Enter a rating for your Activity...",
                                      },
                                      domProps: { value: _vm.formData.rating },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.formData,
                                            "rating",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "form__label",
                                        attrs: { for: "rating" },
                                      },
                                      [_vm._v("Activity rating")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "form__validation" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.errors.first("rating"))
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form__group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.formData.address,
                                          expression: "formData.address",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                        },
                                      ],
                                      staticClass: "form__control",
                                      attrs: {
                                        id: "address",
                                        name: "address",
                                        placeholder:
                                          "Enter an address for your Activity...",
                                      },
                                      domProps: { value: _vm.formData.address },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.formData,
                                            "address",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "form__label",
                                        attrs: { for: "address" },
                                      },
                                      [_vm._v("Activity address")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "form__validation" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.errors.first("address"))
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form__group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.formData.directionUrl,
                                          expression: "formData.directionUrl",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                        },
                                      ],
                                      staticClass: "form__control",
                                      attrs: {
                                        id: "directionUrl",
                                        name: "directionUrl",
                                        placeholder:
                                          "Enter a direction URL for your Activity...",
                                      },
                                      domProps: {
                                        value: _vm.formData.directionUrl,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.formData,
                                            "directionUrl",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "form__label",
                                        attrs: { for: "directionUrl" },
                                      },
                                      [_vm._v("Activity direction URL")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "form__validation" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors.first("directionUrl")
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "form__group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.formData.activityRoom,
                                  expression: "formData.activityRoom",
                                },
                                { name: "validate", rawName: "v-validate" },
                              ],
                              staticClass: "form__control",
                              attrs: {
                                id: "activityRoom",
                                name: "activityRoom",
                                placeholder:
                                  "Enter a room for your Activity...",
                              },
                              domProps: { value: _vm.formData.activityRoom },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.formData,
                                    "activityRoom",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form__label",
                                attrs: { for: "activityRoom" },
                              },
                              [_vm._v("Activity room")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "form__validation" }, [
                              _vm._v(_vm._s(_vm.errors.first("activityRoom"))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form__group" },
                            [
                              _c("FileUpload", {
                                attrs: {
                                  multiple: false,
                                  name: "background",
                                  label: "Background Image",
                                },
                                model: {
                                  value: _vm.formData.background.uuid,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.background,
                                      "uuid",
                                      $$v
                                    )
                                  },
                                  expression: "formData.background.uuid",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form__group form__group--submit" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn--primary",
                                  attrs: { type: "submit" },
                                },
                                [_vm._v("Save")]
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                ],
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }